/**
 * Resource Table
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'resource-table-dropdown';

class ResourceTable extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        select: this.element.querySelector('select[name="download"]')
    };

    /**
     * On Select Change
     */
    onSelectChange = (e) => {
        const { value } = e.currentTarget;
        if (value && value !== 'none') {
            if (typeof window.piraEnablePDFViewer === 'function' && value.endsWith('.pdf')) {
                window.piraEnablePDFViewer(value);
            } else {
                window.open(value);
            }
            e.currentTarget.value = 'none'; // reset select so (same) language can be reselected
        }
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.elements.select.addEventListener('change', this.onSelectChange);
    };

    /**
     * Initialize Component
     */
    init() {
        if (!this.elements.select) return;
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, ResourceTable);
